import appConfig from '@/config/appConfig.typed';
import appContent from '@/services/content/appContent';
import connectivityService from '@/services/device/connectivityService';

export const getConnectionContent = () => {
    const isBle = connectivityService.isBle();
    const connectionFlow = isBle ? appContent.getBleConnectionFlow() : appContent.getUsbConnectionFlow();

    return connectionFlow;
};

export const getConnectionFlowSettings = () => {
    const isBle = connectivityService.isBle();
    const connectionFlowSettings = isBle
        ? appConfig.getBleConnectionFlowSettings()
        : appConfig.getUsbConnectionFlowSettings();

    const connectionFlowSettingsArray = [
        connectionFlowSettings.connectionDuration,
        connectionFlowSettings.registrationDuration,
        connectionFlowSettings.synchronizationDuration,
    ];

    return connectionFlowSettingsArray;
};
